//Grids are all 15x15 each nubmber represents a sprite image
export const Cliffside = [
    [ 3,  3,   3,   3,   3,   3,   3,   3,   3,   3,   3,   3,   3,   3,   3],
    [ 3, 44,  45,  46,  47,   3,   3,   3,   3,   3,   3,   3,   3,   3,   3],
    [ 3, 48,  49,  50,  51,   3,   3,   3,  44,  45,  46,  47,   3,   3,   3],
    [ 3,  3,   3,   3,   3,   3,   3,   3,  48,  49,  50,  51,   3,   3,   3],
    [ 3,  3,   3,   3,   3,   3,   3,   3,   3,   3,   3,   3,   3,   3,   3],
    [ 3,  3,   3,   3,   3,   3,   3,   3,   3,   3,   3,   3,   3,   3,   3],
    [41, 41,  41,  41,  41,  41,  41,   3,   3,   3,   3,   3,  52,  53,   3],
    [30,  3,   3,   3,   3,   3,   3,  43,   3,   3,   3,  54,  55,  56,  57],
    [42, 42,  42,  42,  42,  42,  42,   0,   3,   3,   3,  58,  59,  60,  61],
    [ 1,  1,   1,   1,   1,   1,   2,   3,   3,   3,  62,  63,  64,  65,  66],
    [ 1,  1,   1,   1,   1,   2,   3,  67,  68,  69,  70,  71,  72,  73,  74],
    [ 1,  1,   1,   1,   2,  75,  76,  77,  78,  79,  80,  81,  82,  83,  84],
    [ 1,  1,   1,   2,  85,  86,  87,  88,  89,  90,  91,  92,  93,  94,  95],
    [ 1,  1,   2,   3,  96,  97,  98,  99, 100, 101, 102, 103, 104, 105, 106],
    [ 1,  2, 107, 108, 109, 110, 111, 112, 113, 114, 115, 116, 117, 118, 119],
]

export const Castle = [   
    [ 40,  40,  40, 40,   40,  40,  40,  40,  40,  40,  40,  40,  40,  40,  40],
    [ 40,  40,  40, 40,   40,  40,  40,  40,  40,  40, 123,  40,  40,  40,  40],
    [ 40,   4,   4,  4,    4,   4,  40,   4,   4,   4,  4,  330, 331, 332,   4],
    [ 40,   4,  40, 40,   40,   4,  40,   4,  40,   4, 325, 326, 327, 328, 329],
    [ 40,   4,   4,  4,   40,   4,  40,   4,  40,   4, 320, 321, 322, 323, 324],
    [ 40,  40,  40,  4,   40,   4,   4,   4,  40,   4, 315, 316, 317, 318, 319],
    [120, 121, 120,  7,  120, 121, 120, 121, 120, 121, 310, 311, 312, 313, 314],
    [  31,   6,  40,  7, 120, 121, 120, 121, 120, 121, 120, 121, 122, 120, 121],
    [  4,   6,  40,  7,   40,  40,  40, 129, 129, 129,  40,  40,   6,   6,   6],
    [  4,   6,  40,  7,   40, 125, 126, 130, 130, 130, 125, 126,   6,   4,   4],
    [  4,   6,  40,  6,   40, 127, 128,   6,   6,   6, 127, 128,   6,   4,   4],
    [  4,   6,  6,  6,   6,   6,   6,   6,   6,   6,   6,   6,   6,   4,   4],
    [  4,   4,   4,  4,    4,   4,   4,   4,   4,   4,   4,   4,   4,   4,   4],
    [ 137, 137, 137, 137, 137, 137, 137, 137, 137, 137, 137, 137, 137, 137, 137],
    [ 131, 131, 131, 131, 131, 131, 131, 131, 131, 131, 131, 131, 131, 131, 131],
]

export const CastleGuardMoved = [   
    [ 40,  40,  40, 40,   40,  40,  40,  40,  40,  40,  40,  40,  40,  40,  40],
    [ 40,  40,  40, 40,   40,  40,  40,  40,  40,  40, 123,  40,  40,  40,  40],
    [ 40,   4,   4,  4,    4,   4,  40,   4,   4,   4,  4,  330, 331, 332,   4],
    [ 40,   4,  40, 40,   40,   4,  40,   4,  40,   4, 325, 326, 327, 328, 329],
    [ 40,   4,   4,  4,   40,   4,  40,   4,  40,   4, 320, 321, 322, 323, 324],
    [ 40,  40,  40,  4,   40,   4,   4,   4,  40,   4, 315, 316, 317, 318, 319],
    [120, 121, 120,  7,  120, 121, 120, 121, 120, 121, 310, 311, 312, 313, 314],
    [  31,   6,  40,  7, 120, 121, 120, 121, 120, 121, 120, 121,   6, 120, 121],
    [  4,   6,  40,  7,   40,  40,  40, 129, 129, 129,  40,  40,   6, 122,   6],
    [  4,   6,  40,  7,   40, 125, 126, 130, 130, 130, 125, 126,   6,   4,   4],
    [  4,   6,  40,  6,   40, 127, 128,   6,   6,   6, 127, 128,   6,   4,   4],
    [  4,   6,  6,  6,   6,   6,   6,   6,   6,   6,   6,   6,   6,   4,   4],
    [  4,   4,   4,  4,    4,   4,   4,   4,   4,   4,   4,   4,   4,   4,   4],
    [ 137, 137, 137, 137, 137, 137, 137, 137, 137, 137, 137, 137, 137, 137, 137],
    [ 131, 131, 131, 131, 131, 131, 131, 131, 131, 131, 131, 131, 131, 131, 131],
]

export const Forest = [
    [40, 40,  4, 230, 231, 232, 233, 234,   4,  40,  40,  40,  40,  40, 40],
    [40, 40,  4, 235, 236, 237, 238, 239,   4,  40, 132, 137, 137, 133, 40],
    [40, 40,  4, 240, 241, 242, 243, 244,   4,   7, 136, 131, 131, 138, 40],
    [40, 40,  4, 245, 246, 247, 248, 249,   4,  40, 136, 131, 131, 138, 40],
    [40, 40,  4,   4,   4,   6,   4,   4,   4,   7, 136, 131, 131, 138, 40],
    [40, 40,  4,   4,   4,   6,   6,   6,   4,  40, 134, 139, 139, 135, 40],
    [40, 40, 40,  40,  40,  40,   4,   6,   4,   4,   4,   4,   4,   4, 40],
    [31,  6,  6,   4,  40,   7,   4,   6,   6,   6,  40,  40,  40,  40, 40],
    [ 4,  4,  6,   4,  40,   7, 132, 137, 133,   6,  6,  6,   6,   6,  6],
    [ 4,  4,  6,   6,   4,   7, 136, 131, 138,   6,  40,   4, 251, 252, 40],
    [ 4,  4,  4,   6,   4,  40, 134, 139, 135,   6,   40,   4, 253, 254, 40],
    [40,  4,  4,   6,   4,  40,  40,  40,  40,   250,  40,  40,  40,  40, 40],
    [40,  4,  4,   6,   6,   6,   6,   6,   6,   6,   4,   4,   4,   4, 40],
    [40, 40,  4,   4,   4,   4,   4,   4,   4,   4,   4,   4,   4,  40, 40],
    [40, 40, 40,  40,  40,  40,   4,  40,  40,  40, 40,  40,  40,  40, 40]
]

export const ForestThiefMoved = [
    [40, 40,  4, 230, 231, 232, 233, 234,   4,  40,  40,  40,  40,  40, 40],
    [40, 40,  4, 235, 236, 237, 238, 239,   4,  40, 132, 137, 137, 133, 40],
    [40, 40,  4, 240, 241, 242, 243, 244,   4,   7, 136, 131, 131, 138, 40],
    [40, 40,  4, 245, 246, 247, 248, 249,   4,  40, 136, 131, 131, 138, 40],
    [40, 40,  4,   4,   4,   6,   4,   4,   4,   7, 136, 131, 131, 138, 40],
    [40, 40,  4,   4,   4,   6,   6,   6,   4,  40, 134, 139, 139, 135, 40],
    [40, 40, 40,  40,  40,   40,   4,   6,   4,   4,   4,   4,   4,   4, 40],
    [31,  6,  6,   4,  40,   7,   4,   6,   6,   6,  40,  40,  40,  40, 40],
    [ 4,  4,  6,   4,  40,   7, 132, 137, 133,   6,  250,  6,   6,   6,  6],
    [ 4,  4,  6,   6,   4,   7, 136, 131, 138,   6,  40,   4, 251, 252, 40],
    [ 4,  4,  4,   6,   4,  40, 134, 139, 135,   6,  40,   4, 253, 254, 40],
    [40,  4,  4,   6,   4,  40,  40,  40,  40,   6,  40,  40,  40,  40, 40],
    [40,  4,  4,   6,   6,   6,   6,   6,   6,   6,   4,   4,   4,   4, 40],
    [40, 40,  4,   4,   4,   4,   4,   4,   4,   4,   4,   4,   4,  40, 40],
    [40, 40, 40,  40,  40,  40,   4,  40,  40,  40, 40,  40,  40,  40, 40]
]

// Village uses existing 64px assets. Tile 32 is the legacy world-map exit;
// the configured east exit is handled by the centralized transition registry.
export const Village = [
    [40, 40, 40,  40,  40,  40,   4,  40,  40,  40, 40,  40,  40,  40, 40],
    [40,125,126,  4,  8,  8,  8,  4,  4,  4,125,126,  4,  4, 40],
    [40,127,128,  4,  8,  8,  9,  8,  4,  4,127,128,  4,  4, 40],
    [40,  4,  4,  4,  4,  8,  9,  8,  4,  4,  4,  4,  4,  4, 40],
    [40,  4,  4,  8,  8,  9,  9,  9,  8,  8,  4,  4,  4,  4, 40],
    [40,  4, 39,  8,  9,  9,  9,  9,  8,  4, 40,  4,141,  4, 40],
    [40,  4,  4,  8,  9,  9,  9,  9,  8,  4,  4,  4,  4,  4, 40],
    [40,  8,  8,  8,  8,  9,  9,  9,  8,  8,  8,  8,  8,  8, 32],
    [40,  4, 40,  4,  8,  9,  9,  9,  8,  4, 40,  4,  4,  4, 40],
    [40,  4, 40,  4,  8,  9,  9,  9,  8,  4, 40,  4,142,  4, 40],
    [40,125,126,  4,  8,  8,  9,  8,  8,  4,  4,  4,  4,  4, 40],
    [40,127,128,  4,  4,  4,  8,  8,  8,  4, 40, 40, 40, 40, 40],
    [40,  4,  4,  4,  4,  4,  8,  4,143,251,252,  4,  4,  4, 40],
    [40,  4,  4,  4,  4,  4,  8,  4,  4,253,254,  4,  4,  4, 40],
    [40, 40, 40,  40,  40,  40,   4,  40,  40,  40, 40,  40,  40,  40, 40]
]

// Lake Bed: a winding stone trail skirts an irregular lake before entering the rock face.
export const LakeBed = [
    [40, 40, 40, 10, 10, 10,373,373,375,302,375,373,373, 40, 40],
    [40, 10, 40, 10, 10, 10,374,376,375,  6,374,376,375, 40, 40],
    [40, 40, 10,370, 10, 10, 10, 10,  6,  6,374,376,375, 40, 40],
    [40, 10, 10, 10,371, 10, 10, 10, 10, 10,379,  6,  6,375, 40],
    [40, 10, 10, 10, 10, 10, 10, 10, 10,  6,  6,  6, 39, 39, 40],
    [40, 10, 10, 10, 10, 10, 10, 10,  6,  6, 10, 10, 39, 40, 40],
    [40, 10, 10, 10, 10, 10,  6,  6,  6, 10, 10,374,376,375, 40],
    [ 6,  6,  6,132,137,137,137,137,137,133,  6,  6,  6,375,375],
    [40, 10,  6,136,131,131,131,131,131,138,  6,  6,379,374, 40],
    [40, 10,  6,136,131,131,131,131,131,138,  6,  6,377,375, 40],
    [40, 40,  6,136,131,131,131, 12,131,138,  6,377,377,375, 40],
    [40, 10,  6,134,139,139,139, 12,139,135,  6,372, 10, 10, 40],
    [40, 10,  6,  6,  6,  6,  6,  6,  6,  6,  6,363, 10, 10, 40],
    [40, 40,10, 10, 10, 10, 10, 10, 10, 10, 10, 10, 40, 40, 40],
    [40, 40,10, 10, 10, 10, 40, 10, 10, 10, 10, 10, 40, 40, 40]
];

// Dragon Cave: dark walkable stone, a clear ring around the dragon, and blocked set dressing.
export const DragonCave = [
    [390,391,391,391,391,391,391,391,391,391,391,391,391,391,390],
    [392, 13, 13, 14, 13, 13, 13, 13, 13, 13, 14, 13, 13, 13,392],
    [392, 13, 13, 13,396, 13, 13, 13, 13,396, 13, 13,395, 13,392],
    [392, 13, 13,396, 13, 13, 13, 13, 13, 13,396, 13, 13, 13,392],
    [392, 13,396, 13, 13, 13, 13, 13, 13, 13, 13,396, 13, 13,392],
    [392, 13, 13, 13, 13, 13, 13, 13, 13, 13, 13, 13, 13, 13,392],
    [392, 13, 13,395,380,380,380,380,380, 13, 395, 13, 13, 13,392],
    [392, 13, 13, 13,381,381,381,381,381, 13, 13, 13, 13, 13,392],
    [392, 13,395, 13,380,380,380,380,380, 13, 13,395, 13, 13,392],
    [392, 13, 13, 13, 13, 13, 13, 13, 13, 13, 13, 13, 13, 13,392],
    [392, 13, 13, 13, 13, 13, 13, 13, 13, 13, 13, 13, 13, 13,392],
    [392, 13, 13, 13, 13, 13, 13, 13, 13, 13, 13, 13, 13, 13,392],
    [392, 13, 13, 13, 13, 13, 13, 13, 13, 13, 13, 13, 13, 13,392],
    [392, 13, 13, 13, 13, 13, 13, 13, 13, 13, 13, 13, 13, 13,392],
    [393,393,393,393,393,393,393,302,393,393,393,393,393,393,393]
];
